// extracted by mini-css-extract-plugin
export default {"container":"style_container__i2Gsy","autoScroll":"style_autoScroll__VR0ex","buttonWrapper":"style_buttonWrapper__E3-f5"};